/* ACU routing measurement v1. Analytics-only; native Shopify app owns ecommerce. */
(function () {
  'use strict';
  if (window.AcuRouteMetrics) return;
  const node = document.getElementById('AcuRoutingConfig');
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  const host = window.location.hostname.toLowerCase().replace(/^www\./, '');
  const store = host === 'acupuncture1993.com' ? 'global' : host === 'acupuncture1993.co.uk' ? 'uk' : null;
  const query = new URLSearchParams(window.location.search);
  if (!store || config.themeRole !== 'main' || config.designMode || window.Shopify?.designMode || window.Shopify?.visualPreviewMode || query.has('preview_theme_id') || query.has('preview_key')) return;
  if (/\/(?:checkouts?|account|localization)(?:\/|$)/i.test(window.location.pathname)) return;
  const id = 'G-B4VJGHG5TZ';
  const version = 'route-v1-20261103';
  let ready = false, probing = false, timer = null, attempts = 0, entered = false, presentation = 0, viewed = 0;
  let resolved = null, decision = false;
  const pending = [];
  const status = { version, store, transport: 'waiting-for-consent', queued: 0, sent: 0 };
  function allowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  }
  function foreground() { return document.visibilityState === 'visible'; }
  function visibleSelector() {
    const dialog = document.getElementById('acu-region-gateway');
    return !!(dialog && dialog.open && dialog.getClientRects().length && foreground());
  }
  // Use the Google & YouTube app's existing queue. Never configure or load a second tag.
  function tag() { window.dataLayer.push(arguments); }
  function deliver(name, params, observed) {
    if (!allowed() || (!observed && !foreground())) return false;
    if (!ready) {
      if (pending.length >= 20) return false;
      pending.push([name, params]);
      status.queued = pending.length;
      load();
      return true;
    }
    tag('event', name, Object.assign({
      send_to: id, store_key: store, selector_version: version,
      route_rule_version: 'existing-router-v2', page_type: config.pageType || 'unknown',
      page_path: window.location.pathname,
      page_location: window.location.origin + window.location.pathname
    }, params));
    status.sent++;
    return true;
  }
  function load() {
    if (ready || timer || !allowed() || attempts >= 60) return;
    status.transport = 'waiting-for-native-tag';
    attempts++;
    const configured = Array.isArray(window.dataLayer) && window.dataLayer.some(function (command) { return command && command[0] === 'config' && command[1] === id; });
    if (configured && !probing) {
      probing = true;
      // The documented get callback verifies the intended native GA4 destination is configured.
      tag('get', id, 'session_id', function (session) {
        probing = false;
        if (!allowed() || session == null) return;
        ready = true;
        status.transport = 'native-tag-ready';
        if (timer) { window.clearTimeout(timer); timer = null; }
        const items = pending.splice(0);
        status.queued = 0;
        items.forEach(function (item) { deliver(item[0], item[1], true); });
        assess();
      });
    }
    if (!ready) timer = window.setTimeout(function () { timer = null; load(); }, 500);
  }
  function assess() {
    if (!allowed() || !foreground()) return;
    if (visibleSelector()) {
      if (!presentation) presentation++;
      if (viewed !== presentation && deliver('acu_selector_view', {})) viewed = presentation;
      return;
    }
    if (entered || config.destinationPage || !resolved || resolved === 'pending' || /gateway|redirect|preview|protected|navigation-failed/.test(resolved)) return;
    const entry = resolved === 'global-choice' ? 'selector_global' : resolved === 'global-dismiss' ? 'selector_dismiss' : resolved === 'global-preference' ? 'remembered_global' : query.get('acu_store') === 'global' ? 'global_link' : config.pageType === 'index' ? 'direct_home' : 'direct_deep_link';
    if (deliver('acu_storefront_enter', {entry_method: entry})) entered = true;
  }
  function consentChanged() {
    if (!allowed()) {
      if (pending.some(function (item) { return item[0] === 'acu_storefront_enter'; })) entered = false;
      if (pending.some(function (item) { return item[0] === 'acu_selector_view'; })) viewed = 0;
      pending.length = 0;
      status.queued = 0;
      if (timer) { window.clearTimeout(timer); timer = null; }
      return;
    }
    attempts = 0;
    load();
    assess();
  }
  window.AcuRouteMetrics = {
    status,
    shown: function () { presentation++; decision = false; assess(); },
    resolved: function (result) { resolved = result; assess(); },
    choice: function (destination, method) {
      if (decision || !visibleSelector()) return;
      assess();
      decision = true;
      deliver('acu_selector_choice', {destination_store: destination, choice_method: method});
    },
    dismiss: function (method) {
      if (decision || !visibleSelector()) return;
      assess();
      decision = true;
      deliver('acu_selector_dismiss', {dismiss_method: method});
    },
    transfer: function (destination, method, reason) {
      deliver('acu_store_transfer', {source_store: store, destination_store: destination, transfer_method: method, route_reason: reason});
    }
  };
  document.addEventListener('visitorConsentCollected', consentChanged);
  document.addEventListener('visibilitychange', function () { if (foreground()) { attempts = 0; load(); assess(); } });
  document.addEventListener('load', function (event) {
    if (event.target?.tagName === 'SCRIPT' && /^https:\/\/www\.googletagmanager\.com\//.test(event.target.src || '')) { attempts = 0; load(); }
  }, true);
  window.addEventListener('pageshow', assess);
  try {
    if (window.Shopify?.customerPrivacy) consentChanged();
    else if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function (error) { if (!error) consentChanged(); else status.transport = 'privacy-api-unavailable'; });
    }
  } catch (_) { status.transport = 'unavailable'; }
})();

/* Acupuncture continuation v2. First-party country detection; never routes theme previews. */
(function () {
  'use strict';
  if (window.AcuRegion) return;
  const configNode = document.getElementById('AcuRoutingConfig');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  const countries = new Set(['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','CH','NO']);
  const preferenceKey = 'acu_destination_choice';
  const attemptKey = 'acu_uk_redirect_at';
  const state = { result: 'pending', detectedCountry: null };
  let dialog, returnFocus, started = false, deliberateGlobal = false;
  const root = (config.rootUrl || '/').replace(/\/?$/, '/');
  const query = new URLSearchParams(window.location.search);

  function preference() {
    try {
      const raw = window.localStorage.getItem(preferenceKey);
      if (!raw) return { readable: true, global: false };
      let value;
      try { value = JSON.parse(raw); } catch (_) { return { readable: true, global: false }; }
      return { readable: true, global: value.destination === 'global' && Number(value.expiry) > Date.now() };
    } catch (_) { return { readable: false, global: false }; }
  }
  function metric(method, ...args) { try { window.AcuRouteMetrics?.[method](...args); } catch (_) { /* Measurement must not block shopping. */ } }
  function finish(result) { state.result = result; metric('resolved', result); return result; }
  function closeGateway() {
    if (dialog) {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
    }
    document.documentElement.classList.remove('acu-region-active');
    if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus();
  }
  function chooseGlobal(method) {
    if (method === 'close' || method === 'escape') metric('dismiss', method);
    else if (method === 'button') metric('choice', 'global', 'button');
    deliberateGlobal = true;
    try { window.localStorage.setItem(preferenceKey, JSON.stringify({ destination: 'global', expiry: Date.now() + 7 * 86400000 })); } catch (_) { /* A deliberate choice still applies to this page. */ }
    closeGateway();
    if (config.destinationPage) window.location.assign(root + '?acu_store=global');
    return finish(method === 'close' || method === 'escape' ? 'global-dismiss' : method === 'link' ? 'global-link' : 'global-choice');
  }
  function openGateway() {
    dialog = document.getElementById('acu-region-gateway');
    if (!dialog) return false;
    const wasOpen = dialog.open;
    returnFocus = document.activeElement;
    document.documentElement.classList.add('acu-region-active');
    try {
      if (typeof dialog.showModal === 'function') { if (!dialog.open) dialog.showModal(); }
      else dialog.setAttribute('open', '');
      const first = dialog.querySelector('#acu-global');
      if (first) first.focus();
      if (!wasOpen) metric('shown');
      return true;
    } catch (_) { closeGateway(); return false; }
  }
  function bindGateway() {
    dialog = document.getElementById('acu-region-gateway');
    if (dialog && !dialog.dataset.acuBound) {
      dialog.dataset.acuBound = 'true';
      dialog.addEventListener('cancel', function (event) { event.preventDefault(); chooseGlobal('escape'); });
      dialog.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab') return;
        const controls = Array.from(dialog.querySelectorAll('a[href], button:not([disabled])')).filter(function (node) { return node.getClientRects().length > 0; });
        if (!controls.length) return;
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    }
    document.addEventListener('click', function (event) {
      const target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      if (target.closest('#acu-global, [data-acu-global]')) { event.preventDefault(); chooseGlobal(target.closest('#acu-global') ? 'button' : 'close'); }
      else if (target.closest('#acu-europe')) {
        metric('choice', 'europe_external', 'link');
        metric('transfer', 'europe_external', 'selector_link', 'explicit_europe');
      }
      else if (target.closest('[data-acu-open-gateway]')) { event.preventDefault(); openGateway(); }
    });
  }
  function isPreview() {
    const shopify = window.Shopify || {};
    return config.themeRole !== 'main' || config.designMode === true || shopify.designMode === true ||
      shopify.visualPreviewMode === true || query.has('preview_theme_id') || query.has('preview_key');
  }
  function protectedPath() {
    const pathname = window.location.pathname;
    const relative = pathname.startsWith(root) ? pathname.slice(root.length) : pathname.replace(/^\//, '');
    return /^(checkouts?|account|localization)(\/|$)/i.test(relative);
  }
  async function json(url) {
    const controller = new AbortController();
    const timer = window.setTimeout(function () { controller.abort(); }, 2500);
    try {
      const response = await window.fetch(url, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Routing request failed');
      return await response.json();
    } finally { window.clearTimeout(timer); }
  }
  function destination() {
    try {
      const url = new URL(config.ukUrl || 'https://www.acupuncture1993.co.uk/');
      if (url.protocol !== 'https:' || !['www.acupuncture1993.co.uk','acupuncture1993.co.uk'].includes(url.hostname.toLowerCase()) || url.port || url.username || url.password) return null;
      if (['www.acupuncture1993.co.uk','acupuncture1993.co.uk'].includes(window.location.hostname.toLowerCase())) return null;
      // Fixed native Shopify 301, verified to reach our separate UK store.
      // Keep Shopify's cross-site security listener intact; never accept a target query parameter.
      if (['www.acupuncture1993.com','acupuncture1993.com'].includes(window.location.hostname.toLowerCase()) && url.href === 'https://www.acupuncture1993.co.uk/') return '/acu-uk-store';
      return url.href;
    } catch (_) { return null; }
  }
  function recordAttempt() {
    try {
      const last = Number(window.sessionStorage.getItem(attemptKey));
      if (last && Date.now() - last < 300000) return false;
      window.sessionStorage.setItem(attemptKey, String(Date.now()));
      return true;
    } catch (_) { return false; }
  }
  async function start() {
    if (started) return state.result;
    started = true;
    bindGateway();
    if (isPreview()) {
      if (config.destinationPage || query.get('acu_gateway') === '1') return finish(openGateway() ? 'manual-gateway' : 'gateway-unavailable');
      return finish('preview');
    }
    if (protectedPath()) return finish('protected-path');

    if (config.enabled === true) {
      let country;
      try {
        const result = await json(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false');
        country = result && result.detected_values && result.detected_values.country && result.detected_values.country.handle;
        state.detectedCountry = typeof country === 'string' ? country.toUpperCase() : null;
      } catch (_) { state.detectedCountry = null; }
      if (state.detectedCountry === 'GB') {
        const target = destination();
        if (!target) return finish('invalid-or-same-destination');
        recordAttempt(); // A prior Global visit cannot override a confirmed UK IP.
        metric('transfer', 'uk', 'automatic_redirect', 'uk_ip');
        try { window.location.assign(target); return finish('redirect-uk'); } catch (_) { return finish('navigation-failed'); }
      }
    }
    if (query.get('acu_store') === 'global') return chooseGlobal('link');
    if (config.destinationPage || query.get('acu_gateway') === '1') return finish(openGateway() ? 'manual-gateway' : 'gateway-unavailable');
    if (preference().global) return finish('global-preference');
    if (config.gatewayEnabled !== false && config.pageType === 'index' && countries.has(config.localeCountry)) {
      return finish(openGateway() ? 'eu-gateway' : 'gateway-unavailable');
    }
    return finish('global');
  }
  window.AcuRegion = { state: state, start: start, openGateway: openGateway, chooseGlobal: chooseGlobal, closeGateway: closeGateway };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window.AcuRegion.ready = start(); }, { once: true });
  else window.AcuRegion.ready = start();
})();

